import { render, staticRenderFns } from "./SiatRiepilogoPraticheListComponent.vue?vue&type=template&id=455c77aa&scoped=true"
import script from "./SiatRiepilogoPraticheListComponent.vue?vue&type=script&lang=js"
export * from "./SiatRiepilogoPraticheListComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatRiepilogoPraticheListComponent.vue?vue&type=style&index=0&id=455c77aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c77aa",
  null
  
)

export default component.exports